module.exports = __webpack_public_path__ + "static/media/wrong-number.a2ec497b.svg";